import React, { useState, useEffect } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useLinesContext } from '../../../contexts/Lines';
import { IProduct as Product } from 'frontend/src/Types';
import { sortByDate } from '../../../utils';
import MobileLine from '../../BuildingBlocks/Lines/Mobile/MobileLine';
import MobileProduct from '../../BuildingBlocks/Product/MobileProduct';
import Box from '@material-ui/core/Box';
import Step from '../BuildingBlocks/Stepper/Step';
import MobileEditLineDialog from '../../BuildingBlocks/Lines/Mobile/MobileEditLineDialog';

export default function MobileReviewLines() {
  const mobile = useMobile('sm');
  const { goForward } = useOnboardingContext();
  const { products, lines } = useLinesContext();
  const [product, setProduct] = useState<Product>();

  const lineOnEdit = lines?.find((line) => line.edit);

  useEffect(() => {
    if (!lines) return;
    const product = products.find((p) => (p.id = lines[0].product));
    setProduct(product);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lines]);

  async function handleSubmit() {
    goForward();
  }

  return (
    <>
      <Step
        onSubmit={handleSubmit}
        component={() => (
          <>
            {mobile && (
              <>
                {product && <MobileProduct product={product} />}
                {sortByDate(lines).map((line, i) => {
                  return (
                    <Box mt={2} key={line.id}>
                      <MobileLine line={line} />
                    </Box>
                  );
                })}
              </>
            )}
          </>
        )}
      />
      <MobileEditLineDialog line={lineOnEdit} />
    </>
  );
}
